import { mapConfig } from '@/webtrekk_tracking/config'
import isEqual from 'lodash-es/isEqual'

export const trackingContext = {
  bind: (el, binding, _vnode) => {
    el.dataset.acContext = JSON.stringify(mapConfig(binding.value))
  },
  update: (el, binding, vnode) => {
    if (!isEqual(binding.oldValue, binding.value)) {
      // prevent jquery from caching changed tracking-context values whilst keeping $().data cache for tracking lookups
      $(el).removeData('ac-context')
      el.dataset.acContext = JSON.stringify(mapConfig(binding.value))
    }
  }
}

export const manualTrack = (el, config) => {
  EventBus.trigger('tracking:vueEventTrack', { el, config: mapConfig(config) })
}

export const clickTrack = {
  bind: (el, binding, vnode) => {
    el.$clickTrackData = binding.value
    const handler = () => {
      manualTrack(el, el.$clickTrackData)
    }
    el.addEventListener('click', handler)
    // TODO: figure out whether we actually need this (because it keeps the click event above from firing).
    // el.$destroy = () => el.removeEventListener('click', handler)
    // },
    // unbind: (el, _binding, _vnode) => {
    // el.$destroy()
  },
  update: (el, binding, vnode) => {
    el.$clickTrackData = binding.value
  }
}
